import { render } from "./UsefulTraining.vue?vue&type=template&id=3cd4f341"
import script from "./UsefulTraining.vue?vue&type=script&lang=ts"
export * from "./UsefulTraining.vue?vue&type=script&lang=ts"
script.render = render

export default script